module.exports = __webpack_public_path__ + "static/media/logo_sq.0dabc3d7.png";